var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.887,
    height: 33,
    viewBox: "0 0 48.887 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    d: "M.072,34.145V6.991q0-.047.141-.9L16.195,19.767.261,35.088a4,4,0,0,1-.189-.943ZM2.193,4.209a2.032,2.032,0,0,1,.8-.141H46.036a2.669,2.669,0,0,1,.849.141L30.856,17.928l-2.121,1.7-4.2,3.441-4.2-3.441-2.121-1.7Zm.047,32.717L18.316,21.511l6.223,5.044,6.223-5.044L46.838,36.927a2.264,2.264,0,0,1-.8.141H2.995a2.135,2.135,0,0,1-.754-.141Zm30.643-17.16L48.818,6.1a2.814,2.814,0,0,1,.141.9V34.145a3.613,3.613,0,0,1-.141.943Z",
    transform: "translate(-0.072 -4.068)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.030aaea5.svg";
export { ForwardRef as ReactComponent };